<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>周期计划</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入计划名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新建周期计划</el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <!-- <div class="content-filter">
        <c-filter></c-filter>
      </div> -->
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          size="mini"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column label="名称" prop="name" width="180px" fixed></el-table-column>
          <el-table-column
            prop="startTime"
            label="计划首次执行时间"
            min-width="150"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="endTime" label="计划截止时间" min-width="150px"></el-table-column>
          <el-table-column
            prop="lastTime"
            label="上一次执行时间"
            min-width="150px"
          ></el-table-column>
          <el-table-column
            prop="nextTime"
            label="下一次执行时间"
            min-width="150px"
          ></el-table-column>
          <el-table-column prop="times" label="已执行次数" min-width="150px"></el-table-column>
          <el-table-column
            prop="state"
            label="计划执行状态"
            min-width="120px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                scope.row.state == 0
                  ? '未启用'
                  : scope.row.state == 1
                  ? '进行中'
                  : scope.row.state == 2
                  ? '已结束'
                  : scope.row.state == -1
                  ? '已取消'
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column prop="stateMemo" label="执行情况" min-width="150px"></el-table-column>
          <el-table-column
            prop="repeatTypeCount"
            label="重复类型数量"
            min-width="100px"
          ></el-table-column>
          <el-table-column
            prop="repeatType"
            label="重复类型"
            min-width="120px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ osg.codelabel('planTimeType', scope.row.repeatType) }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    查看
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="execPlan(scope.row)">
                    立即执行
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          size="mini"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      id="planDialog"
      title="周期计划信息"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
    >
      <div style="height: 100%; display: flex; flex-direction: column">
        <el-steps :active="stepsActive" finish-status="success">
          <el-step :title="'请选择' + formName"></el-step>
          <el-step title="请配置服务计划"></el-step>
        </el-steps>
        <div v-show="stepsActive == 0" style="height: 100%; display: flex; flex-direction: column">
          <div style="height: 0; flex: 1">
            <div style="margin: 10px 0" class="c-flex c-flex-item c-flex-between">
              <el-input
                style="width: 260px"
                placeholder="请输入要查询的内容"
                v-model="formSearchValue"
                clearable
                @clear="
                  formFpi.page = 1;
                  formData.targetType == 0 ? getExtFormById() : getContact();
                "
                @keyup.enter.native="
                  formFpi.page = 1;
                  formData.targetType == 0 ? getExtFormById() : getContact();
                "
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    formFpi.page = 1;
                    formData.targetType == 0 ? getExtFormById() : getContact();
                  "
                ></el-button>
              </el-input>
              <div>
                已选择
                <span class="c_blue">
                  {{ (formData.targetTypeId2 && formData.targetTypeId2.length) || 0 }}
                </span>
                条数据
              </div>
            </div>
            <el-table
              ref="formTable"
              height="calc(100% - 80px)"
              :data="formFpi.data"
              @selection-change="selectionChange"
              :row-key="getRowKey"
            >
              <el-table-column
                type="selection"
                :reserve-selection="true"
                v-if="selectionShow"
              ></el-table-column>
              <c-table :fields="extFields"></c-table>
            </el-table>
            <el-pagination
              class="pagination"
              @size-change="pageSizeChange($event, 'formFpi')"
              @current-change="pageChange($event, 'formFpi')"
              :current-page="formFpi.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="formFpi.rows"
              layout="total, sizes, prev, pager, next, jumper"
              :total="formFpi.total"
            ></el-pagination>
          </div>
        </div>
        <el-form
          v-if="stepsActive == 1"
          :model="formData"
          ref="formData"
          :rules="rules"
          label-width="160px"
          label-position="left"
          hide-required-asterisk:true
          style="margin-top:10px;"
        >
          <el-alert
            v-if="templateList.length"
            style="border: 1px solid; margin: 24px 0px; padding-bottom: 0"
            type="success"
            :closable="false"
          >
            <template slot="title">
              <span class="c-m-r-15">快速配置，选择计划模板并将其信息快速填入表单</span>
              <el-button
                size="mini"
                v-for="(item, index) in templateList"
                :key="index"
                class="c-m-b-10"
                @click="templateCopy(item)"
              >
                {{ item.name }}
              </el-button>
            </template>
          </el-alert>
          <el-form-item prop="name" label="名称">
            <el-input v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item label="按计划创建时间后" prop="timeTypeCount">
            <el-col>
              <template v-if="$util.isShowField(formData, 'timeType', 'timeType', '0')">
                <el-col :span="24">
                  <el-select
                    style="width:100%"
                    v-model="formData.timeType"
                    clearable
                    @change="
                      () => {
                        delete formData.timeTypeCount;
                      }
                    "
                  >
                    <el-option
                      v-for="item in options.planTimeType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
                <!-- <el-col class="line" :span="12" :offset="1">创建即刻执行周期计划</el-col> -->
              </template>
              <template v-else>
                <el-col :span="3" v-if="!$util.isShowField(formData, 'timeType', 'timeType', '0')">
                  <el-input-number
                    type="number"
                    style="width: 100%"
                    :step="1"
                    step-strictly
                    :controls="false"
                    :min="0"
                    v-model="formData.timeTypeCount"
                  ></el-input-number>
                </el-col>
                <el-col :span="10" :offset="1">
                  <el-select
                    v-model="formData.timeType"
                    clearable
                    @change="
                      () => {
                        delete formData.startTime;
                      }
                    "
                  >
                    <el-option
                      v-for="item in options.planTimeType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col class="line" :span="9" :offset="1">执行周期计划</el-col>
              </template>
            </el-col>
          </el-form-item>
          <template v-if="$util.isShowField(formData, 'timeType', 'timeType', '0')">
            <el-form-item label="开始执行计划时间" prop="startTime">
              <el-date-picker
                v-model="formData.startTime"
                type="datetime"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择开始执行计划时间"
              ></el-date-picker>
            </el-form-item>
          </template>
          <el-form-item label="重复周期" prop="repeatTypeCount">
            <template v-if="$util.isShowField(formData, 'repeatType', 'repeatType', '0')">
              <el-select
                v-model="formData.repeatType"
                @change="
                  () => {
                    delete formData.repeatTypeCount;
                    delete formData.repeatTimesLimit;
                  }
                "
                clearable
              >
                <el-option
                  v-for="item in options.planTimeType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
            <template v-else>
              <el-col>
                <el-col class="line" :span="2">每隔</el-col>
                <el-col :span="3">
                  <el-input-number
                    type="number"
                    style="width: 100%"
                    :step="1"
                    step-strictly
                    :controls="false"
                    :min="0"
                    v-model="formData.repeatTypeCount"
                  ></el-input-number>
                </el-col>
                <el-col :span="10" :offset="1">
                  <el-select v-model="formData.repeatType" clearable>
                    <el-option
                      v-for="item in options.planTimeType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col class="line" :span="7" :offset="1">重复一次</el-col>
              </el-col>
            </template>
          </el-form-item>
          <el-form-item
            prop="repeatTimesLimit"
            label="重复次数"
            v-if="!$util.isShowField(formData, 'repeatType', 'repeatType', '0')"
          >
            <el-input-number
              type="number"
              style="width: 100%"
              :step="1"
              step-strictly
              :controls="false"
              :min="0"
              v-model="formData.repeatTimesLimit"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="开始执行周期计划后" prop="repeatTypeCount">
            <template
              v-if="$util.isShowField(formData, 'repeatDeadlineType', 'repeatDeadlineType', '0')"
            >
              <el-select v-model="formData.repeatDeadlineType" clearable>
                <el-option
                  v-for="item in options.planTimeType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
            <template v-else>
              <el-col>
                <el-col :span="3">
                  <el-input-number
                    type="number"
                    style="width: 100%"
                    :step="1"
                    step-strictly
                    :controls="false"
                    :min="0"
                    v-model="formData.repeatDeadlineTypeCount"
                  ></el-input-number>
                </el-col>
                <el-col :span="10" :offset="1">
                  <el-select v-model="formData.repeatDeadlineType" clearable>
                    <el-option
                      v-for="item in options.planTimeType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col class="line" :span="7" :offset="1">停止执行周期计划</el-col>
              </el-col>
            </template>
          </el-form-item>
          <template
            v-if="$util.isShowField(formData, 'repeatDeadlineType', 'repeatDeadlineType', '0')"
          >
            <el-form-item label="截止时间" prop="repeatDeadlineDueTime">
              <el-date-picker
                v-model="formData.repeatDeadlineDueTime"
                type="datetime"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择截止时间"
              ></el-date-picker>
            </el-form-item>
          </template>
          <!-- <el-form-item label="所属组织">
            <el-cascader
              ref="orgIds"
              placeholder="可搜索组织名称"
              :options="options.orgs"
              :show-all-levels="false"
              :props="{
                checkStrictly: true,
                emitPath: false,
                label: 'orgName',
                value: '_id',
                children: 'orgList'
              }"
              filterable
              clearable
              v-model="orgIdSearch"
              @change="
                getServiceResources();
                formData.userId = '';
              "
            ></el-cascader>
          </el-form-item> -->
          <el-form-item label="执行人">
            <el-select
              filterable
              v-model="formData.bizId"
              clearable
              @change="$forceUpdate()"
              placeholder="可以输入姓名搜索"
            >
              <el-option
                v-for="item in options.serviceResources"
                :key="item.relatedRecordId"
                :label="item.name"
                :value="item.relatedRecordId"
              >
                <span style="float: left">{{ item.name }}</span>
                <span
                  style="float: right; color: #8492a6; font-size: 13px"
                  v-if="item.resourceRoles && item.resourceRoles.length > 0"
                >
                  角色：{{ osg.codelabelForArray('resourceRoles', item.resourceRoles) }}
                </span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务动作" prop="groovyScriptId">
            <el-select filterable clearable v-model="formData.groovyScriptId">
              <el-option
                v-for="item in options.groovyScriptList"
                :key="item._id"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item
            prop="validScriptContent"
            label="新增执行脚本"
          >
            <el-input type="textarea" v-model="formData.validScriptContent"></el-input>
          </el-form-item>
          <el-form-item
            prop="invalidScriptContent"
            label="删除执行脚本"
          >
            <el-input type="textarea" v-model="formData.invalidScriptContent"></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <div slot="footer" style="display: flex; justify-content: space-between">
        <el-button @click="stepsBack" v-if="stepsActive > 0">上一步</el-button>
        <el-button @click="doInit" v-else>取 消</el-button>

        <el-button type="primary" @click="stepsNext()" v-if="stepsActive == 0">下一步</el-button>
        <el-button type="primary" @click="doSave" v-if="!formData._id && stepsActive == 1">
          提 交
        </el-button>
        <el-button type="primary" @click="doInit" v-if="formData._id && stepsActive == 1">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  name: 'CyclePlans',
  data() {
    return {
      name: 'plan',
      refresh: true,
      fpi: {}, //周期计划列表数据
      formFpi: { data: [] }, //表单列表数据
      searchValue: '', //周期计划搜索
      formSearchValue: '', //表单搜索
      openDetail: false,
      formData: { targetTypeId2: [] },
      extFields: [], //表单字段
      extField: {},
      rules: this.$util.rules,
      options: {
        codecfg_planTimeType: { codeId: 'planTimeType' }, //时间类型
        codecfg_IS: { codeId: 'IS' }, // 是否
        codecfg_planSourceType: { codeId: 'planSourceType' }, //创建来源
        codecfg_resourceRoles: { codeId: 'resourceRoles' } //资源角色
      },
      //地址级联
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //只能选择今天及今天之后
          //return time.getTime() > Date.now() - 8.64e7; //只能选择今天之前，连今天都不能选
          //return time.getTime() < Date.now() - 8.64e6; //只能选择今天之后，连今天都不能选
          //return time.getTime() > Date.now() - 8.64e6; //只能选择今天及今天之前
        },
        shortcuts: [
          {
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          },
          {
            text: '一个月后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            }
          },
          {
            text: '三个月后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit('pick', date);
            }
          }
        ]
      },
      stepsActive: 0, //步骤索引
      templateList: [], //模板列表
      stringList: [
        'timeType',
        'timeTypeCount',
        'repeatType',
        'repeatTypeCount',
        'repeatTimesLimit',
        'repeatDeadlineType',
        'repeatDeadlineTypeCount'
      ], //字段类型要转string的数组
      orgIdSearch: '', //所属组织
      loginAccount: {},
      // 地址栏传参
      colName: '', // 动态表单或业务档案表名
      formName: '', // 动态表单或业务档案表名称
      targetType: '', // 0动态表单；1流程；2流程节点；3业务档案
      targetTypeId: '', // targetType=0时为ext表id
      formFields: [], // 动态表单或业务档案-字段
      selectionShow: false
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    this.doInit();
    this.targetType = this.osg.param('targetType') || 3;
    this.colName = this.osg.param('colName') || 'contacts';
    if (this.targetType == 0 || this.targetType == 3) {
      this.getExtByColName();
    }
    this.osg.codeoption(() => {
      this.osg.getFpi();
      this.getData(); //获取周期计划
      this.getGroovyScript(); //脚本列表
      this.getTemplate(); //模板列表
      this.getServiceResources();
    });
  },
  methods: {
    pageSizeChange(pageSize, fpiName) {
      fpiName = fpiName || 'fpi';
      this[fpiName].rows = pageSize;
      fpiName == 'fpi'
        ? this.getData()
        : this.formData.targetType == 0
        ? this.getExtFormById()
        : this.getContact();
    },
    pageChange(currentPage, fpiName) {
      fpiName = fpiName || 'fpi';
      this[fpiName].page = currentPage;
      fpiName == 'fpi'
        ? this.getData()
        : this.formData.targetType == 0
        ? this.getExtFormById()
        : this.getContact();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        targetType: this.targetType,
        targetTypeId: this.targetTypeId,
        targetTypeId2: [],
        exts: {}
      };
      this.stepsActive = 0;
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:email|string#or': this.searchValue,
        'ne:state|integer#and': -1,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      //   $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/plan/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    //查询脚本列表
    getGroovyScript() {
      let params = {
        _all: '1',
        'regex:name|string#or': this.formData.groovyScriptId,
        'in:state|array-integer#and': '1',
        'in:type|integer#and': '5',
        sortField: 'workflowDefNodeId,order',
        sortOrder: 'asc'
      };
      this.osg.ajax('groovyScript/query.do', params, res => {
        this.options.groovyScriptList = res.data;
      });
    },
    //获取计划模板
    getTemplate() {
      var params = {
        _all: '1',
        'ne:state|integer#and': -1,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('basic/planTemplate/query.do', params, res => {
        this.templateList = res.data ? res.data : [];
      });
    },
    getExtByColName() {
      this.osg.ajax('biz/ext/queryByColName/' + this.colName + '.do', {}, res => {
        this.formName = res.entity.title;
        this.targetTypeId = res.entity._id;
      });
    },
    getExtFormById() {
      this.osg.ajax(
        `biz/extForm/query/${this.formData.targetTypeId}.do`,
        {
          page: this.formFpi.page,
          rows: this.formFpi.rows,
          'is:state|integer#and': 1,
          'regex:name|string#or': this.formSearchValue,
          'regex:title|string#or': this.formSearchValue,
          'regex:plateNo|string#or': this.formSearchValue,
          'regex:driver|string#or': this.formSearchValue,
          'in:_id|array#and': this.formData.targetTypeId2.join(),
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.exts = item.exts || {};
          });
          this.formFpi = res;
          this.$nextTick(() => {
            this.selectionShow = true;
            this.$refs.formTable.doLayout();
            if (this.formData.targetTypeId2.length > 0) {
              let rows = res.data.filter(item => {
                return this.formData.targetTypeId2.indexOf(item._id) != -1;
              });
              this.toggleSelection(rows);
            } else {
              this.toggleSelection();
            }
          });
        }
      );
    },
    //获取组织
    getOrg() {
      this.osg.ajax('org/query.do', {}, res => {
        let obj = res.data;
        if (this.loginAccount.accountType == 'b') {
          obj._id = this.loginAccount.orgId;
          obj.orgName = this.loginAccount.orgName;
        } else {
          if (this.loginAccount.tenantId == '1340835581184723420') {
            obj.orgName = '顶之美';
          } else {
            obj.orgName = '全部组织';
          }
        }
        this.options.orgs = [obj];
      });
    },
    //获取员工列表
    getServiceResources() {
      this.osg.ajax(
        'biz/serviceResource/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          resourceType: 'technician',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.options.serviceResources = res.data;
        }
      );
    },
    doNew() {
      this.doInit();
      this.osg.getFields(this.colName || 'contacts', () => {
        if (this.targetType == 0) {
          this.getExtFormById();
        } else {
          this.getContact();
        }
      });
      this.openDetail = true;
      this.$nextTick(() => {
        this.toggleSelection();
      });
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.plantoString(row); //字段转字符串
      row.targetTypeId2 = row.targetTypeId2 || [];
      this.formData = row;
      if (row.targetType == 0 || row.targetType == 3) {
        if (row.targetTypeId) {
          this.osg.getFields(
            null,
            () => {
              if (row.targetType == 0) {
                this.getExtFormById();
              } else {
                this.getContact();
              }
            },
            null,
            null,
            row.targetTypeId
          );
        }
      }
      this.stepsActive = 0;
      this.openDetail = true;
    },
    execPlan(row) {
      this.osg.confirm(`是否确认立即执行周期计划：${row.name}？`, () => {
        this.osg.ajax('i/other/execPlan.do?id=' + row._id, {}, () => {
          this.osg.toast('执行成功');
        });
      });
    },
    //获取客户列表
    getContact() {
      var params = {
        page: this.formFpi.page,
        rows: this.formFpi.rows,
        'regex:name|string#or': this.formSearchValue,
        'regex:phone|string#or': this.formSearchValue,
        'regex:email|string#or': this.formSearchValue,
        'in:_id|array#and': this.formData.targetTypeId2.join(),
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('basic/contacts/query.do', params, res => {
        this.formFpi = res;
        this.$nextTick(() => {
          this.selectionShow = true;
          this.$refs.formTable.doLayout();
          if (this.formData.targetTypeId2.length > 0) {
            let rows = res.data.filter(item => {
              return this.formData.targetTypeId2.indexOf(item._id) != -1;
            });
            this.toggleSelection(rows);
          } else {
            this.toggleSelection();
          }
          this.$forceUpdate();
        });
      });
    },
    //上一步
    stepsBack() {
      if (this.stepsActive-- < 1) this.stepsActive = 0;
    },
    //下一步
    stepsNext() {
      if (
        this.stepsActive == 0 &&
        (!this.formData.targetTypeId2 || !this.formData.targetTypeId2.length)
      ) {
        this.osg.toast('请至少勾选1条数据', 'warning');
        return;
      }
      if (this.stepsActive++ >= 1) {
        this.doSave();
        this.stepsActive = 1;
      }
    },
    doSave() {
      if (this.osg.validate()) {
        this.osg.ajax('basic/plan/upsert.do', this.formData, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    //复制模板的信息
    templateCopy(row) {
      row = this.$util.deepCopy({
        // executionTime: row.executionTime,
        // isRepeat: String(row.isRepeat),
        // moveUpTime: row.moveUpTime,
        // moveUpType: row.moveUpType,
        // repeatType: row.repeatType,
        // groovyScriptId: row.groovyScriptId,
        // validScriptContent: row.validScriptContent,
        // invalidScriptContent: row.invalidScriptContent,
        // count: row.count,
        templateId: row._id,
        name: row.name,
        timeType: row.timeType,
        timeTypeCount: row.timeTypeCount,
        repeatType: row.repeatType,
        repeatTypeCount: row.repeatTypeCount,
        repeatTimesLimit: row.repeatTimesLimit,
        repeatDeadlineType: row.repeatDeadlineType,
        repeatDeadlineTypeCount: row.repeatDeadlineTypeCount,
        repeatDeadlineDueTime: row.repeatDeadlineDueTime,
        groovyScriptId: row.groovyScriptId
      });
      this.plantoString(row); //字段转字符串
      this.formData = this.$util.deepCopy(Object.assign(this.formData, row));
    },
    //字段转字符串
    plantoString(row) {
      for (let item of this.stringList) {
        if (row[item] !== undefined || row[item] !== null) row[item] = String(row[item]);
      }
    },
    doEnable(id) {
      this.$prompt('请输入原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '原因不能为空',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(({ value }) => {
          console.log(value);
          this.osg.ajax('basic/plan/enable.do', { id, stateMemo: value }, () => {
            this.getData();
            this.osg.toast('操作成功！');
          });
        })
        .catch(() => {
          //   this.osg.toast('取消审核', 'info');
        });
    },
    doDisable(id) {
      this.$prompt('请输入原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '原因不能为空',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(({ value }) => {
          console.log(value);
          this.osg.ajax('basic/plan/disable.do', { id, stateMemo: value }, () => {
            this.getData();
            this.osg.toast('操作成功！');
          });
        })
        .catch(() => {
          //   this.osg.toast('取消审核', 'info');
        });
    },
    doRemove(id) {
      this.osg.confirm('确定要删除吗？', () => {
        this.osg.ajax('basic/plan/remove.do', { id }, res => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    //获取地理编码
    async getGeocode() {
      if (this.formData.area[0] && this.formData.area[1]) {
        var citys = await this.$util.getCity(this.formData.area[0]);
        var cityName = '';
        for (var city of citys) {
          if (city._id == this.formData.area[1]) {
            cityName = city.name;
            break;
          }
        }
        this.osg.geocode(cityName + this.formData.address, res => {
          if (res.location) {
            this.formData.gpsPoint = {
              longitude: res.location.split(',')[0],
              latitude: res.location.split(',')[1]
            };
          }
          this.$forceUpdate();
        });
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.formTable.toggleRowSelection(row, true);
        });
      } else {
        this.$refs.formTable.clearSelection();
      }
    },
    // 保存表单数据id
    selectionChange(rows) {
      let arr = [];
      rows.map(item => {
        arr.push(item._id);
      });
      this.formData.targetTypeId2 = arr;
    },
    getRowKey(row) {
      return row._id;
    }
  },
  watch: {
    //area 级联组件点击label就消失
    'formData.area'() {
      if (this.$refs.areaSelector) {
        this.$refs.areaSelector.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    //信息渠道,级联组件点击label就消失
    'formData.channel'() {
      if (this.$refs.channelCascader) {
        this.$refs.channelCascader.dropDownVisible = false; //监听值发生变化就关闭它
      }
    }
  }
};
</script>
<style>
#planDialog .el-dialog__body {
  height: 80vh;
}
.el-alert--success.is-light {
  background-color: #f0f9eb;
  color: #67c23a;
  opacity: 0.9;
}
</style>
